import * as React from 'react'
import { useLongPress } from 'use-long-press'
import { I18n } from 'react-redux-i18n'

const Index = (props) => {
  React.useEffect(() => {
    reloadGrid()
  }, [props.schedule])
  const [gridElements, setGridElementss] = React.useState([])
  //const [hoverMode, setHoverMode] = React.useState(false)
  const callback = React.useCallback(e => {
    onHoldTile()
  }, [])
  const bind = useLongPress(callback, {
    onStart: event => {},
    onFinish: event => {
      //setHoverMode(false)
    },
    onCancel: event => {},
    threshold: 500,
    captureEvent: true,
    detect: 'both',
  })

  const ranges = new Array(24).fill(0)

  const rangeLabels = ranges.map((range, index) => {
    return (
      <div className='hour-range' key={index}>{index < 10 ? `0${index}:00` : `${index}:00`}</div>
    )
  })

  const onClickTile = (dayIndex, rangeIndex) => {
    props.cicleTileStatus(dayIndex, rangeIndex).then(() => {
      reloadGrid()
    })
  }

  const onHoldTile = () => {
    //setHoverMode(true)
  }

  const onHoverTile = (dayIndex, rangeIndex) => {
    //console.log(dayIndex, rangeIndex, hoverMode)
  }

  const reloadGrid = () => {
    setGridElementss (
      props.schedule.map((day, dayIndex) => {
        return (
          <div className='day-row' key={day.label}>
            <div className='day-label'>
              {I18n.t(`dashboard_${day.label}`)}
            </div>
            {day.ranges.map((range, rangeIndex) => {
              return (
                <div
                  key={`${dayIndex}-${rangeIndex}`}
                  className='tile'
                  style={{ backgroundColor: getTileColor(range) }}
                  onClick={() => onClickTile(dayIndex, rangeIndex)}
                  onMouseEnter={() => onHoverTile(dayIndex, rangeIndex)}
                  {...bind}
                />
              )
            })}
          </div>
        )
      })
    )
  }

  const getTileColor = (status) => {
    switch (status) {
      case 0:
        return '#F1F1F1'
      case 1:
        return '#f59528'
      case 2:
        return '#dd601d'
      case 3:
        return '#2c2d2d'
      default:
        return '#F1F1F1'
    }
  }

  return (
    <>
      <div className='hour-row'>
        <div className='hour-label'>HORA</div>
        {rangeLabels}
      </div>
      {
        gridElements
      }
    </>
  )
}

export default Index